<div class="fcp-alert {{ type }} {{ size }}" *ngIf="show">
    <div class="fcp-alert-icon-container {{ type }}">
        <fcp-icon class="fcp-alert-icon {{ type }}" [icon]="['fas', iconName]"></fcp-icon>
    </div>
    <div class="fcp-alert-text fcp-text-body-m">
        <ng-content></ng-content>
        <div class="fcp-alert-right-container" *ngIf="showClose || additionalText.show">
            <div class="fcp-alert-right-container-text" *ngIf="additionalText.show">
                <div *ngIf="!additionalText.action" class="fcp-alert-additional-text">
                    {{ additionalText.value }}
                </div>
                <div *ngIf="additionalText.action" class="fcp-alert-additional-text-action">
                    <a (click)="handleAction()" fcp-link>
                        {{ additionalText.value }}
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="fcp-alert-button" *ngIf="showClose" (click)="onClickAlertClosed()">
        <fcp-icon class="fcp-alert-button-icon" [icon]="['fas', 'times']"></fcp-icon>
    </div>
</div>
